<template>
    <div class="d-flex flex-column gap-4">
        <IncludedOrderStatesBox :order-states="statistics.order_states"/>

        <apexchart type="bar"
                   :height="(statistics.data.length * 60 * 4) + 'px'"
                   :options="chartOptions"
                   :series="series"
        />
    </div>
</template>

<script>
import OrderStatisticsLayout from "@layouts/Statistics/OrderStatisticsLayout.vue";
import IncludedOrderStatesBox from "@components/Stats/IncludedOrderStatesBox.vue";
import tinycolor from "tinycolor2";

export default {
    components: {IncludedOrderStatesBox},

    layout: OrderStatisticsLayout,

    props: {
        stores: Object,
        statistics: {
            types: [Object, Array]
        },
    },

    data() {
        return {
            chartOptions: {
                chart: {
                    id: 'chartBarSeries',
                    type: 'bar',
                    animations: {
                        enabled: true,
                        easing: 'easeout',
                        speed: 180
                    },
                    toolbar: {
                        show: false
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        borderRadius: 4,
                        borderRadiusApplication: 'right',
                        barHeight: '32px'
                    },
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'left',
                    labels: {
                        useSeriesColors: true
                    },
                },
                xaxis: {
                    categories: this.statistics.data.map(storeStatistics => {
                        let store = this.stores[storeStatistics.store_uuid];

                        return [
                            store.attributes.name + ',',
                            store.attributes.address.street1 + ',',
                            store.attributes.address.city
                        ];
                    })
                },
                yaxis: {
                    show: true
                }
            }
        }
    },

    mounted() {
        this.toggleSalesVolumeBar()
    },

    methods: {
        calculateAverageOrderAmount(totalSalesVolume, totalOrders) {
            if (totalOrders === 0) {
                return 0;
            }

            return totalSalesVolume / totalOrders;
        },

        toggleSalesVolumeBar() {
            let chart = ApexCharts.getChartByID('chartBarSeries');
            chart.toggleSeries(this.__('orders.sales_volume'));
        }
    },

    computed: {
        series() {
            return [
                {
                    name: this.__('orders.orders'),
                    color: '#795BF3',
                    data: this.statistics.data.map(item => item['total_orders']),
                    group: 'bars'
                },
                {
                    name: this.__('general.articles'),
                    color: tinycolor('#795BF3').desaturate(10).darken(10).toHexString(),
                    data: this.statistics.data.map(item => item['items_sold']),
                    group: 'bars'
                },
                {
                    name: this.__('orders.sales_volume'),
                    color: tinycolor('#795BF3').desaturate(10).darken(20).toHexString(),
                    data: this.statistics.data.map(item => item['total_value_without_shipping']),
                    group: 'sales'
                },
                {
                    name: 'ø ' + this.__('orders.value'),
                    color: '#242939',
                    data: this.statistics.data.map(data => this.calculateAverageOrderAmount(data.total_value_without_shipping, data.items_sold).toFixed(2)),
                    group: 'bars'
                }
            ];
        }
    },

    watch: {
        statistics: {
            deep: true,
            handler(newValue, oldValue) {
                this.$nextTick(() => this.toggleSalesVolumeBar())
            }
        }
    }
}
</script>
